import React from 'react';
import Typography from 'helpers/fonts';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import './labeled-select.css';

export interface IOptionProps {
  label: string | number;
  value: string | number | boolean;
}

export interface LabeledSelectProps {
  options: Array<IOptionProps>;
  title: string;
  selected: string | number | boolean;
  onSelect: (value: number | string | boolean) => void;
}

const LabeledSelect: React.FunctionComponent<LabeledSelectProps> = ({
  options,
  title,
  selected,
  onSelect,
}: LabeledSelectProps) => {
  const { t } = useTranslation();
  return (
    <span style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Typography styleid={6}>{t(`${title}`)}</Typography>
      <Select
        style={{ width: '100%' }}
        value={selected as any}
        onSelect={onSelect as any}
      >
        {options.map((o) => (
          <Select.Option key={o.label} value={o.value as any}>
            <Typography styleid={6}>{o.label}</Typography>
          </Select.Option>
        ))}
      </Select>
    </span>
  );
};

export default LabeledSelect;
